import { LoaderIcon } from "@components/atoms/Icons";
import { translate } from "@locales";

interface Props{
  className: string;
}

export function Loader({className}: Props) {
  return (
    <div className={className}>
      <LoaderIcon />
      <span>{translate("loading")}</span>
    </div>
  );
}
